import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { GetAll } from "adminApi/Terms&PrivacySocialApi/Terms&PrivacySocial";
import DataTable from "Common/DataTable/DataTable";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import fields from "../../json/TermsAndPrivacyFields.json";
import { FilterStatus } from "utils/FilterStatus"


const TermsAndPrivacyTable = () => {
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledataTermsAndPrivacy } = fields;

  // Fetch hook (no search needed here)
  const { data, meta, loading, error, refetch } = usePaginatedFetch(
    GetAll,
    {
      page,
      limit,
      title: "Terms and Privacy",
    }
  );

  const displayFields = generateDisplayFields(tabledataTermsAndPrivacy)


  const filterdata = FilterStatus(data);

  const { formattedData, columns } = useTableConfig({
    data: filterdata,
    page,
    limit,
    canShowAction,
    refetch,
    IsDelete: false,
    config: {
      entityName: "Terms and Privacy",
      editUrl: `edit-terms-and-privacy`,
      idKey: "id",
      displayFields,
      deleteApi: null, // No delete for this table
    },
  });

  const onPageChange = (p) => setPage(p);
  
  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default TermsAndPrivacyTable;
